//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'videojs-contrib-hls';
import noVideo from "../../assets/img/noVideo.png";
import yesVideo from "../../assets/img/yesVideo.png";
export default {
  filters: {
    videoOption: function videoOption(val) {
      var vPic = val.indexOf('.m3u8') > -1 ? yesVideo : noVideo;
      return {
        live: false,
        preload: 'auto',
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        autoplay: true,
        // 如果为true,浏览器准备好时开始回放
        language: 'zh-CN',
        aspectRatio: '5:4',
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true,
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: val // url地址

        }],
        poster: vPic,
        // 封面地址
        notSupportedMessage: '该设备未添加监控或配置错误',
        // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          // 当前时间和持续时间的分隔符
          durationDisplay: false,
          // 显示持续时间
          remainingTimeDisplay: false,
          // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮

        }
      };
    }
  },
  data: function data() {
    return {
      generatedColors: [],
      // 存放动态生成的颜色
      colors: {
        menuBarBackgroundColor: '#999',
        homePageBackgroundColor: '#999',
        titleColor: '#999',
        textColor: '#999',
        buttonColor: '#999',
        buttonColor2: '#999'
      },
      buttonStyle: {
        color: '#ffffff',
        fontSize: '20px',
        fontWeight: 'bold',
        fontFamily: '微软雅黑',
        backgroundColor: 'rgb(50, 65, 87)',
        borderColor: '#ffffff',
        borderWidth: '3px',
        marginTop: '-20px'
      },
      param: {
        username: '',
        password: ''
      },
      deviceName: '',
      isshow: false,
      screenheight: '',
      picsrc: '../../assets/img/searchempty.jpg',
      name: localStorage.getItem('ms_username'),
      structArr: [],
      balanceArr: [],
      columnNum: 24,
      ishasData: true,
      isShowVideo: true,
      timer: 0,
      activeName: 'first',
      videoFlag: 0
    };
  },
  created: function created() {
    this.getstructArr();
    this.getSystemInfo();
  },
  mounted: function mounted() {
    var _this = this;

    if (this.timer) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(function () {
        _this.getstructArr();
      }, 1000 * 2);
    }
  },
  destroyed: function destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    gotolink: function gotolink(param1, param2) {
      //指定跳转地址
      this.$router.push({
        path: "/MoreDeviceInfo",
        query: {
          id: param1,
          videoUrl: param2
        }
      });
    },
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    },
    getData: function getData() {
      this.ishasData = true;
    },
    getstructArr: function getstructArr() {
      var _this2 = this;

      var username = localStorage.getItem('ms_username');
      var userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
      this.$zybhttp.post('Business/GetIndexData', {
        Field1: userInfo.userType,
        Field2: userInfo.realName
      }).then(function (res) {
        if (res.data.status == 0) {
          var data = res.data.data.list;

          for (var i = 0; i < data.length; i++) {
            data[i].insFlow = parseFloat(data[i].insFlow).toFixed(2);
            data[i].beltSpeed = parseFloat(data[i].beltSpeed).toFixed(2);
            var videoUrl = data[i].monitorEqu;
            videoUrl = videoUrl == '' ? '' : "".concat(_this2.GlobalConfig.baseUrl, "VideoStream/").concat(data[i].monitorEqu, "/video.m3u8");
            data[i].monitorEqu = videoUrl;
            _this2.yData = [];

            for (var key in data[i].hourData) {
              _this2.yData.push(data[i].hourData[key].weight);
            }
          }

          if (_this2.balanceArr.length == data.length) {
            _this2.balanceArr = data;
          } else {
            _this2.balanceArr = JSON.parse(JSON.stringify(data));
          }

          var dataLength = _this2.balanceArr.length;

          if (dataLength > 0) {
            _this2.ishasData = true;
          } else {
            _this2.ishasData = false;
          }
        } else {
          _this2.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this2.$notify.error('网络异常！获取列表失败！');
      });
    },
    getSystemInfo: function getSystemInfo() {
      var _this3 = this;

      this.$zybhttp.get('Business/GetSystemInfo', {}).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data;
          _this3.version = d.msg;
          _this3.colors.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
          _this3.colors.homePageBackgroundColor = d.data.list[0].homePageBackgroundColor;
          _this3.colors.titleColor = d.data.list[0].titleColor;
          _this3.colors.textColor = d.data.list[0].textColor;
          _this3.colors.buttonColor = d.data.list[0].buttonColor;
          _this3.colors.buttonColor2 = d.data.list[0].buttonColor2;
          _this3.buttonStyle.color = _this3.colors.textColor; // 修改文字颜色为红色

          _this3.buttonStyle.backgroundColor = _this3.colors.buttonColor; // 修改背景色为蓝色

          _this3.buttonStyle.borderColor = _this3.colors.textColor; // 修改边框颜色为绿色
        } else {
          _this3.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this3.$notify.error('网络异常！获取列表失败！');
      });
    },
    getButtonStyle: function getButtonStyle(item) {
      return {
        color: this.buttonStyle.color,
        fontSize: '20px',
        fontWeight: 'bold',
        fontFamily: '微软雅黑',
        backgroundColor: item.isHovered ? this.colors.buttonColor2 : this.colors.buttonColor,
        borderColor: this.buttonStyle.borderColor,
        borderWidth: '3px',
        marginTop: '-20px'
      };
    },
    changeHoverColor: function changeHoverColor(item) {
      this.$set(item, 'isHovered', true); // this.buttonStyle.backgroundColor = this.colors.buttonColor2;
    },
    resetColor: function resetColor(item) {
      this.$set(item, 'isHovered', false); // this.buttonStyle.backgroundColor = this.colors.buttonColor;
    },
    generateColors: function generateColors(n) {
      var colors = [];

      for (var i = 0; i < n; i++) {
        // HSL 方式生成色相分布均匀的颜色
        var hue = Math.floor(360 / n * i);
        colors.push("hsl(".concat(hue, ", 70%, 50%)"));
      }

      return colors;
    },
    getCumulativeColor: function getCumulativeColor(index) {
      if (!this.generatedColors || this.generatedColors.length !== this.balanceArr.length) {
        this.generatedColors = this.generateColors(this.balanceArr.length);
      }

      return this.generatedColors[index];
    },
    labelClass: function labelClass(item) {
      return item.Connect === '连接成功' ? 'titleleftYes' : 'titleleftNo';
    },
    valueClass: function valueClass(item) {
      return item.Connect === '连接成功' ? 'contentrightYes' : 'contentrightNo';
    }
  }
};